/** @jsx jsx */
import { gql } from '@apollo/client';
import { Label } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function ExhibitorStand({ exhibitor: { stand }, ...rest }) {
  if (!stand || !stand.title) return null;
  return <Label {...rest}>{stand.title}</Label>;
}

export const fragment = graphql`
  fragment ExhibitorStand on Exhibitor {
    stand {
      title: title
    }
  }
`;

export const ExhibitorStandFragment = gql`
  fragment ExhibitorStand on Exhibitor {
    stand {
      title: name
    }
  }
`;
